export default __webpack_public_path__ + "images/AC.8f6256c.png";